module.exports = require("@tiptap/extension-table-row");